import styled from "styled-components";

export const Faq = styled.div`
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px;
    gap: 52px;

    #info-faq {
      #div-one {
        #span-faq {
          font-weight: 700;
          font-size: 12px;
          line-height: 122%;
          text-transform: uppercase;
          color: var(--orange);
        }

        h1 {
          font-weight: 700;
          font-size: 24px;
          line-height: 122%;
          color: var(--title);
          margin-bottom: 30px;
        }

        p {
          font-weight: 400;
          font-size: 14px;
          line-height: 160%;
          color: var(--title);

          span {
            text-transform: uppercase;
            font-weight: 900;
          }
        }
      }

      #div-two {
        padding: 30px;

        button {
          width: 100%;
          height: 40px;
          border: none;
          border-radius: 2px;
          background-color: var(--title);

          a {
            color: var(--white);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            :visited {
              color: var(--white);
            }
          }

          svg {
            font-size: 18px;
            margin-left: 3px;
          }
        }
      }
    }

    #the-faq {
      display: flex;
      flex-direction: column;
      gap: 50px;

      summary,
      h3 {
        display: flex;
        flex-direction: row;
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--title);
        padding-bottom: 5px;
        cursor: pointer;

        ::-webkit-details-marker {
          display: none;
        }
      }

      h3 {
        width: 90%;
      }

      summary:after {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--orange);
        background: transparent;
        content: "+";
        float: left;
        font-weight: bold;
        padding: 0;
        text-align: center;
        width: 20px;
        height: 20px;
        left: 20px;
        margin-right: 10px;
        border: 2px solid var(--orange);
        border-radius: 50px;
        font-size: 20px;
        cursor: pointer;
      }

      details[open] summary:after {
        content: "-";
      }

      details {
        font-weight: 400;
        font-size: 14px;
        line-height: 160%;
        color: var(--title);
        border-bottom: 1px solid #d4e1f8;
        padding-bottom: 45px;

        a {
          font-weight: 700;
          font-size: 16px;
          line-height: 160%;
          color: var(--orange);
          display: flex;
          align-items: center;
          margin-top: 15px;

          :visited {
            color: var(--orange);
          }

          svg {
            font-weight: 800;
            font-size: 20px;
          }
        }
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      #info-faq {
        display: flex;

        #div-one {
          width: 50%;
        }

        #div-two {
          width: 50%;
          display: flex;
          justify-content: flex-end;
          button {
            width: 50%;
            height: 56px;
          }
        }
      }

      #the-faq {
        width: 100%;
        details {
        }
      }
    }
  }
`;
